import { cn } from "@/lib/utils";
import makaiLogo from "@/assets/makai-logo.png.asset.json";

export function BrandMark({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "inline-grid h-9 w-9 place-items-center rounded-xl bg-[#0B1736] shadow-soft overflow-hidden",
        className,
      )}
      aria-hidden
    >
      <img
        src={makaiLogo.url}
        alt=""
        className="h-full w-full object-contain p-1"
        loading="eager"
        decoding="async"
      />
    </span>
  );
}

export function BrandWord({ className }: { className?: string }) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <BrandMark />
      <div className="flex flex-col leading-none">
        <span className="font-display text-lg font-bold tracking-[0.18em]">
          MAKAI
        </span>
        <span className="mt-0.5 text-[10px] font-medium uppercase tracking-[0.22em] text-muted-foreground">
          Learn · Dream · Grow
        </span>
      </div>
    </div>
  );
}
